module.exports = __webpack_public_path__ + "static/img/WisdomSiteAnquan.df7498f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/WisdomSite/WisdomSiteAnquan.png
// module id = DWKZ
// module chunks = 12